import React from 'react';

/**
 * Gender Switcher component
 */
const BodyConditionInput = (props) => (
  <div className="nppe2-fc-body-condition-input">
    <div className="nppe2-fc-sub-title">
      {props.data.labelBodyWeight}
    </div>
    <div className="nppe2-fc-body-condition-input__container" >
      <input type="number"
        id="nppe2-fc-validate-current-body-weight"
        min="0"
        step="0.01"
        placeholder="0"
        value={props.selectedBodyWeight}
        onChange={(e) => e.target.value === "" ? props.onSelectBodyWeight("") : props.onSelectBodyWeight(Math.abs(e.target.value))}
        onFocus={(e) => { if (e.target.value === "0") props.onSelectBodyWeight("") }}
        aria-label={props.data.labelBodyWeight}
      />
      <span className="nppe2-fc-body-condition-input__kg">kg</span>
    </div>

    <div className="nppe2-fc-sub-title">
      {props.data.labelIdealBodyWeight}
    </div>
    <div className="nppe2-fc-body-condition-input__container">
      <input
        type="text"
        value={props.idealBodyWeight.toFixed(2)}
        disabled
        aria-label={props.data.labelIdealBodyWeight}
        className="nppe2-fc-body-condition-input__ideal-weight"
      />
      <span className="nppe2-fc-body-condition-input__kg">kg</span>
    </div>
  </div>
);

export default BodyConditionInput;
